var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHomeHeadphonesBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 240.013,
    y1: 3,
    x2: 240.013,
    y2: 476.0856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7241,
    style: {
      stopColor: "#00C5F0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480,240c0-33.9-23.6-63.2-56.7-70.4C415.4,68.4,327.1-7.3,225.8,0.6c-90.3,7-162.1,78.7-169.1,169.1 c-13.5,3-25.9,9.7-35.7,19.5c-28,28-28,73.6,0.2,101.7c10.7,10.6,24.4,17.7,39.2,20.1c1.1,0.6,2.4,1,3.6,1c0.5,0,1-0.1,1.5-0.2 c0.2,0,0.4-0.1,0.6-0.2C68,311.8,70,312,72,312h16c4.4,0,8-3.6,8-8V176c0-4.4-3.6-8-8-8H73C81.6,75.8,163.4,8,255.7,16.6 C336,24.1,399.6,87.7,407.1,168H392c-4.4,0-8,3.6-8,8v128c0,4.4,3.6,8,8,8h16v16c0,61.7-48.2,108.6-113.2,111.7 c-4.6-17-22.2-27.1-39.2-22.4c-17,4.6-27.1,22.2-22.4,39.2s22.2,27.1,39.2,22.4c11.2-3,19.9-11.9,22.6-23.2c74-3.2,129-57,129-127.7 v-17.8c13.2-3.1,25.3-9.7,35-19.2C472.5,277.4,480.1,259.1,480,240z M80,296h-8c-2.3,0-4.7-0.1-7-0.4c-30.7-3.7-52.6-31.7-48.8-62.4 c3.1-25.6,23.4-45.8,49-48.8c2.3-0.3,4.6-0.4,6.8-0.4h8V296z M264,464c-8.8,0-16-7.2-16-16s7.2-16,16-16c8.8,0,16,7.2,16,16 S272.9,464,264,464z M415.1,295.6c-2.3,0.3-4.7,0.4-7,0.4h-8V184h8c30.9-0.1,56.1,24.9,56.2,55.8 C464.3,268.2,443.2,292.1,415.1,295.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeHeadphonesBlue);
export default __webpack_public_path__ + "static/media/icon-home-headphones-blue.838ff0f67ba37922e1363e031920960d.svg";
export { ForwardRef as ReactComponent };